export enum DirectionType {
  asc = 'asc',
  desc = 'desc'
}
